import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	none: {
		id: 'servicedesk-sla-settings.services.fetch-priorities.none',
		defaultMessage: 'None',
		description: 'Label for "None" option in priorities dropdown',
	},
});
